import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAlt, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
export class AttractorGridComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { strength: props.attractor.strength };
    }
    lock() {
        if (this.props.lockObject) {
            this.props.lockObject.lock = true;
        }
    }
    unlock() {
        if (this.props.lockObject) {
            this.props.lockObject.lock = false;
        }
    }
    updateStrength(strength) {
        this.props.attractor.strength = strength;
        this.setState({ strength: strength });
    }
    onView() {
        const scene = this.props.host.getScene();
        if (!scene) {
            return;
        }
        if (this.props.attractor._impostor) {
            this.props.removeImpostor(this.props.attractor);
            this.forceUpdate();
            return;
        }
        this.props.addImpostor(this.props.attractor, this.props.lineIndex);
        this.forceUpdate();
    }
    onControl() {
        this.props.onControl(this.props.attractor, this.props.lineIndex);
    }
    render() {
        const attractor = this.props.attractor;
        const untypedAttractor = attractor;
        return (_jsxs("div", { className: "attractor-step", children: [_jsx("div", { className: "index", children: `#${this.props.lineIndex}` }), _jsx("div", { className: "strength-value", children: attractor.strength.toFixed(2) }), _jsx("div", { className: "strength-slider", children: _jsx("input", { className: "range", type: "range", step: 0.01, min: -10.0, max: 10.0, value: attractor.strength, onChange: (evt) => this.updateStrength(parseFloat(evt.target.value)) }) }), _jsx("div", { className: "attractor-control hoverIcon icon" + (this.props.isControlled(attractor) ? " active" : ""), onClick: () => this.onControl(), children: _jsx(FontAwesomeIcon, { icon: faArrowsAlt }) }), _jsx("div", { className: "attractor-view hoverIcon icon" + (untypedAttractor._impostor ? " active" : ""), onClick: () => this.onView(), children: _jsx(FontAwesomeIcon, { icon: faEye }) }), _jsx("div", { className: "attractor-delete hoverIcon icon", onClick: () => this.props.onDelete(attractor), children: _jsx(FontAwesomeIcon, { icon: faTrash }) })] }));
    }
}
//# sourceMappingURL=attractorGridComponent.js.map